import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class GetFaqService {
  constructor(private http: HttpClient) {}
  loadHelpFaq(): Observable<any> {
    return this.http.get('assets/mocks/help-faq.json');
  }
}
